import { createTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

// BigData Theme Colors
const colors = {
  surface: {
    main: '#121212',
    background: '#121212',
  },
  text: {
    200: '#FFFDE9',
    500: '#FFFDE9B2',
    700: '#FFFDE980',
    disabled: '#FFFDE94D',
  },
  BDprimary: {
    200: '#9DD0FF',
    500: '#4CA7F9',
    700: '#206EB5',
    900: '#0589FF33',
  },
  RPprimary: {
    200: '#FFEB8A',
    500: '#EBB71E',
    700: '#AD8B0C',
    900: 'rgba(235, 183, 30, 0.2)',
  },
  grey: {
    200: '#FFFDE9',
    400: '#FFFDE9B2',
    700: '#404040',
    900: '#1a1a1a',
  },
  green: {
    200: '#00ff88',
    500: '#00ff88',
    700: '#00cc6a',
  },
  red: {
    200: '#ff4444',
    500: '#ff4444',
    700: '#cc3333',
  },
  blue: {
    200: '#9DD0FF',
    500: '#4CA7F9',
    700: '#206EB5',
  },
  yellow: {
    200: '#FFEB8A',
    500: '#EBB71E',
    700: '#AD8B0C',
  },
};

export const bigDataTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      light: colors.BDprimary[200],
      main: colors.BDprimary[500],
      dark: colors.BDprimary[700],
      contrastText: colors.surface.main,
    },
    secondary: {
      light: colors.RPprimary[200],
      main: colors.RPprimary[500],
      dark: colors.RPprimary[700],
      contrastText: colors.text[200],
    },
    background: {
      default: colors.surface.main,
      paper: colors.grey[900],
    },
    text: {
      primary: colors.text[200],
      secondary: colors.text[500],
      disabled: colors.text.disabled,
    },
    success: {
      light: colors.green[200],
      main: colors.green[500],
      dark: colors.green[700],
    },
    error: {
      light: colors.red[200],
      main: colors.red[500],
      dark: colors.red[700],
    },
    warning: {
      light: colors.yellow[200],
      main: colors.yellow[500],
      dark: colors.yellow[700],
    },
    info: {
      light: colors.blue[200],
      main: colors.blue[500],
      dark: colors.blue[700],
    },
  },
  typography: {
    fontFamily: ['Hanken Grotesk', 'Lato', 'sans-serif'].join(','),
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
      background: `linear-gradient(90deg, ${colors.BDprimary[500]}, ${colors.RPprimary[500]})`,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          margin: 0,
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          backgroundColor: colors.surface.main,
          color: colors.text[200],
        },
        html: {
          colorScheme: 'dark',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'unset',
          backgroundColor: colors.grey[900],
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: colors.grey[900],
          border: `1px solid ${colors.grey[700]}`,
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },
        contained: {
          backgroundColor: colors.BDprimary[500],
          '&:hover': {
            backgroundColor: colors.BDprimary[700],
          },
        },
        outlined: {
          borderColor: colors.BDprimary[500],
          color: colors.BDprimary[500],
          '&:hover': {
            borderColor: colors.BDprimary[700],
            backgroundColor: alpha(colors.BDprimary[500], 0.1),
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(colors.BDprimary[500], 0.1),
          color: colors.BDprimary[500],
          border: `1px solid ${alpha(colors.BDprimary[500], 0.3)}`,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: colors.text[200],
          '&:hover': {
            backgroundColor: alpha(colors.text[200], 0.1),
          },
        },
      },
    },
  },
});

